import { extendTailwindMerge } from 'tailwind-merge'

export const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-family': [
        'font-styreneB',
        'font-diatype',
        'font-signifier',
        'font-button',
        'font-heading',
        'font-subheading',
        'font-caption',
        'font-body',
        'font-label',
      ],
      'font-weight': [
        'font-weight-heading',
        'font-weight-subheading',
        'font-weight-caption',
        'font-weight-body',
        'font-weight-button',
        'font-weight-label',
      ],
      'font-size': [
        'text-heading-xl',
        'text-heading-h1',
        'text-heading-h2',
        'text-heading-h3',
        'text-heading-h4',
        'text-heading-h5',
        'text-subheading-lg',
        'text-subheading-md',
        'text-subheading-sm',
        'text-caption',
        'text-body-xl',
        'text-body-lg',
        'text-body-sm',
        'text-button',
        'text-label',
      ],
      'max-w': ['max-w-readable'],
    },
  },
})
